var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('admin-header',{attrs:{"name":_vm.$t('Dashboard'),"title":_vm.title,"add-new":""},on:{"create":_vm.gridView}}),_c('app-card',[_c('router-view',{attrs:{"name":"dashboard"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }